<template>
  <div>
    <el-card class="pd10 mgb-10">
      <div slot="header">
        <h4 class="txt-center mg-0">
          <span>{{ title }}</span>
        </h4>
      </div>
      <div class="max-h overflow_auto">
        <div class="txt-center">
          <div class="fs-14">
            <span v-if="hasFileName">{{ name }}</span>
            <span v-else-if="hasFilePath">{{ value }}</span>
            <span v-else>无</span>
          </div>
        </div>
      </div>
    </el-card>
    <el-row :gutter="10">
      <tempalte v-if="hasFilePath">
        <el-col span="12">
          <el-button
            type="primary"
            size="medium"
            class="whole-row"
            @click="download()"
          >
            <i class="el-icon-download"></i> 下载
          </el-button>
        </el-col>
        <el-col span="12">
          <el-button
            type="primary"
            size="medium"
            class="whole-row"
            @click="previewing()"
          >
            <i class="el-icon-view"></i> 预览
          </el-button>
        </el-col>
      </tempalte>

      <el-col span="24" v-else>
        <el-button
          type="info"
          icon="fa fa-upload"
          size="medium"
          class="whole-row"
          disabled
          >未上传</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { utils } from '@/components'
import URI from 'URI'

export default {
  name: 'index',
  props: {
    value: String,
    /**
     * 文件名称
     */
    name: String,
    title: {
      require: true,
      type: String
    },
    /**
     * 是否显示【预览】按钮
     */
    preview: {
      default: false,
      type: Boolean
    },
    /**
     * 是否包含清除功能
     */
    clearable: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {}
  },
  computed: {
    hasFileName() {
      return utils.isNotEmpty(this.name)
    },
    hasFilePath() {
      return utils.isNotEmpty(this.value)
    },
    url() {
      let protocol = location.protocol
      let url = new URI(this.value)
      // 如果是 https 不能发起 http 的请求
      if (protocol === 'https:') {
        url.protocol(protocol)
      }
      return url.toString()
    }
  },
  methods: {
    download() {
      let link = document.createElement('a')
      link.href = this.url
      link.setAttribute('download', this.name)
      link.setAttribute('target', '_blank')
      link.style.display = 'none'
      document.body.appendChild(link)
      setTimeout(() => {
        link.click()
        document.body.removeChild(link)
      }, 100)
    },
    previewing() {
      if (!this.hasFilePath) return this.$message.warning('没有获取文件地址！')
      window.open(this.url)
    },
    remove() {
      this.$emit('remove')
    }
  }
}
</script>

<style lang="scss" scoped>
.pd10 {
  /deep/ .el-card__header,
  /deep/ .el-card__body {
    padding: 10px;
  }
}

.max-h {
  height: 46px;
}
</style>
